import UserSettings from "../core/constants/UserSettings";
import Config from "../config";
import userSettings from "../core/constants/UserSettings";
import snippets from "./snippets";
import User from "./User";


class Storage {

    static emptyPage = {
        auth_info: {},
        avatar_url: "",
        id: 0,
        interface_id: 0,
        interface_msg: "",
        is_active: false,
        is_enabled: false,
        is_setup_required: false,
        offline_msg: "",
        update_time: "",
        user_id: 0,
        username: "",
        welcome_msg: ""
    };

    static setWebData(webData = null) {
        if (!webData) {
            throw new Error("Storage>setWebData>webData parameter is null!!!");
        }

        Object.keys(webData).map(item => {
            localStorage.setItem(item, JSON.stringify(webData[item]));
        });
    }

    static setUsers(data){
        localStorage.setItem("users", JSON.stringify(data));
    }

    static getModalities() {
        return JSON.parse(localStorage.getItem("modalities"));
    }

    static getReportHeaders() {
        return JSON.parse(localStorage.getItem("report_headers"));
    }

    static setModalities(modalities = []) {
        localStorage.setItem("modalities", JSON.stringify(modalities));
    }

    static getServiceCodeGroups() {
        return JSON.parse(localStorage.getItem("service_code_groups"));
    }

    static getTranslates() {
        return JSON.parse(localStorage.getItem("translations"));
    }

    static getUsers() {
        return JSON.parse(localStorage.getItem("users"));
    }

    static getUsersInfo(id) {
        let t = JSON.parse(localStorage.getItem("users"));
        return t?.[id] ?? undefined
    }

    static checkMobileVerified() {
        return localStorage.getItem('mobile_validated');
    }

    static setMobileVerified(verification) {
        localStorage.setItem('mobile_validated', verification);
    }

    static getUserInfo() {
        return JSON.parse(localStorage.getItem('user_info'));
    }

    static getUsername() {
        return this.getUserInfo()?.username;
    }

    static unsetActivePage() {
        return localStorage.removeItem('active_page');
    }

    static setUserInfo(user) {
        const info = {
            username: user.username,
            display_name: user?.name,
            token: user.ticket,
            tokenTime: new Date(),
            refreshToken: user.refresh_token,
            id: user.user_id,
            department: user.department,
            last_session: user.last_session
        };
        localStorage.setItem('user_info', JSON.stringify(info));
    }

    static setSomeUserInfo(key, value) {
        const info = { ...this.getUserInfo(), [`${key}`]: value}
        localStorage.setItem('user_info', JSON.stringify(info));
    }

    static setUserSettings(user) {
        const settings = {
            calendar: user.configs?.general?.calendar || UserSettings.CAL_PERSIAN,
            language: user.configs?.general?.language || UserSettings.LANG_FA,
            preDownload: user.configs?.advanced_viewer?.pre_download || UserSettings.PRE_DOWNLOAD,
            doubleClick: user.double_click_action || UserSettings.DOUBLE_CLICK_ACTION,
            theme: UserSettings.THEME,
            allowResidentsToVerifyWithMe: user.configs?.general?.allowResidentsToVerifyWithMe || user.allow_residents_to_verify_with_me || false,
            study_filters: user?.study_filters || {},
            study_filters_default: user?.study_filters_default,
            rememberMe: user?.rememberMe || false,
            direction: user.direction,
            studyHeaderFilters: user.studyHeaderFilters,
            isPublic: user.isPublic
        };
        localStorage.setItem('user_settings', JSON.stringify(settings));
    }

    //this function used to remain data saved on UserSetting, but they are not at server response! we saved here like: rememberMe
    static updateUserSettings(user) {
        const settings = {
            calendar: user.configs?.general?.calendar ,
            language: user.configs?.general?.language ,
            doubleClick: user.double_click_action ,
            allowResidentsToVerifyWithMe: user.configs?.general?.allowResidentsToVerifyWithMe ,
            preDownload: user.configs?.advanced_viewer?.pre_download ,
            direction: user.configs?.general?.direction ,
        };
        localStorage.setItem('user_settings', JSON.stringify({...this.getUserSettings(), ...settings}));
    }

    static setSomeUserSettings(key, value) {
        const settings = { ...this.getUserSettings(), [`${key}`]: value}
        localStorage.setItem('user_settings', JSON.stringify(settings));
    }

    static getUserSettings() {
        return JSON.parse(localStorage.getItem('user_settings'));
    }

    static getRememberMe() {
        return this.getUserSettings()?.rememberMe;
    }

    static getUserDoubleClick() {
        return this.getUserSettings()?.doubleClick;
    }

    static getUserAllowResidentToVerify() {
        return this.getUserSettings()?.allowResidentsToVerifyWithMe;
    }

    static setHospitals(value){
        localStorage.setItem("hospitals", JSON.stringify(value))
    }

    static getHospitals() {
        return JSON.parse(localStorage.getItem("hospitals"));
    }
    static getHospitalName() {
        let hospitals = JSON.parse(localStorage.getItem("hospitals"));
        let currentHospital = hospitals ? hospitals.find(hospital => hospital.current === true) : null;

        if(currentHospital)
            return currentHospital.title;
        else
            return Config.owner;
    }

    static setUserInfoWithoutToken(user) {
        const info = this.getUserInfo();
        info.display_name = user.display_name;
        info.avatar = user.avatar_url;
        localStorage.setItem('user_info', JSON.stringify(info));
    }

    static getUserDepartmentInfo(){
        return this.getUserInfo()?.department;
    }
    static getUserDepartmentID(){
        return this.getUserDepartmentInfo()?.id;
    }
    static getUserDepartmentTitle(){
        return this.getUserDepartmentInfo()?.title;
    }

    static isLogin() {
        return !!this.getUserInfo();
    }

    static removeStorageData() {
		const itemToKeep = localStorage.getItem('changeLogVersion');
        localStorage.clear();
        document.cookie = "Ticket= ; expires = Thu, 01 Jan 1900 00:00:00 GMT";
		localStorage.setItem('changeLogVersion', itemToKeep);
    }

    static setLanguage(lang) {
        localStorage.setItem('language', lang)
        localStorage.setItem('userLanguage', lang)
    }

    static getLanguage() {
        try {
            return this.getUserSettings().language
        } catch (error) {
            if (localStorage.getItem('language') !== "undefined" && !snippets.isObjectEmpty(localStorage.getItem('language'))){
                return localStorage.getItem('language')
            } else {
                return Config.lang
            }
        }
    }

    static getCalendar() {
        let userSettings = JSON.parse(localStorage.getItem('user_settings'));
        return userSettings?.calendar;
    }


    static setPageSize(pageSize = 0) {
        localStorage.setItem("pageSize", pageSize)
    }
    
    static getPageSize() {
        return JSON.parse(localStorage.getItem("pageSize"));
    }

    static setUserID(id) {
        localStorage.setItem('userId', id);
    }

    static getUserID() {
        try{
            return JSON.parse(localStorage.getItem("userId"));
        } catch {
            return this.getUserInfo()?.id
        }
    }

    static setUserDisplayName(name) {
        this.setSomeUserInfo("display_name", name)
    }

    static getUserDisplayName(id) {
        if (id){
            try{
                let t = this.getUsers();
                return t[id].display_name
            } catch { return ""}
        } else {
            return this.getUserInfo()?.display_name
        }
    }

    static setTicket(ticket) {
        localStorage.setItem('ticket', ticket);
    }

    static getTicket() {
        return localStorage.getItem('ticket');
    }

    static setNewLogin(response, rememberMe= null) {
        this.setUserInfo(response.data);
        this.setUserSettings({...response.data,
            language: response.data?.configs?.general?.language,
            doubleClick: response.data?.double_click_action,
            allowResidentsToVerifyWithMe: response.data?.configs?.general?.allowResidentsToVerifyWithMe,
            study_filters: response.data?.study_filters,
            study_filters_default: {id: response.data?.default_study_filter_id, used: false},
            rememberMe: rememberMe,
            direction: response.data?.configs?.general?.direction,
            studyHeaderFilters: {},
            isPublic: response.data.is_public
        });
        this.studyHeaderFiltersSet(response.data?.configs?.general?.study_list_headers)
        this.setPageSize(0);
        this.setUserID(response.data?.user_id);
        this.setTicket(response.data?.ticket);
        this.setRoles(response.data?.roles);
        this.setUpdatedAt(response.data?.updated_at);
        this.setLanguage(response.data?.language ?? response.data?.configs?.general?.language);
        this.createUserHistory(response.data?.user_id)
        document.cookie = `Ticket=${response.data.ticket}`;
        User.refreshUser()
    }

    static setEditLogin(response) {
        this.setUserInfo(response.data);
        this.updateUserSettings({...response.data})
        this.setUserID(response.data.user_id);
        this.setUserDisplayName(response.data.name);
        this.setTicket(response.data.ticket);
        this.setLanguage(response.data?.language ?? response.data?.configs?.general?.language);
        document.cookie = `Ticket=${response.data.ticket}`;
    }

    static getRefreshTicket() {
        return this.getUserInfo()?.refreshToken
    }

    static getTicketTime() {
        return Date.parse(this.getUserInfo()?.tokenTime) ?? Date.parse('1900-01-01T00:00:00.000Z');
    }
    
    static setTicketTime(time) {
        let userInfo = {...this.getUserInfo(), tokenTime: time};
		this.setUserInfo(userInfo)
    }
    
    static setTicketTimeFails() {
		let tokenTime = new Date(this.getTicketTime())
	    tokenTime.setDate(tokenTime.getDate() + 1)
		this.setTicketTime(tokenTime)
    }
    
    static setLastLogin(lastSession){
        this.setSomeUserInfo('last_session', lastSession)
    }
    
    static getLastLogin(){
        return this.getUserInfo()?.last_session
    }
    
    static getLastSessionTime() {
        let time = this.getLastLogin()?.create_date
        return time || null
    }

    static getLastSessionIP() {
        let ip = this.getLastLogin()?.ip
        return ip || null
    }

    static setRoles(roles) {
        localStorage.setItem('roles', roles);
    }

    static getRoles() {
        return JSON.parse(localStorage.getItem('roles'));
    }

    static setUpdatedAt(updatedAt) {
        localStorage.setItem('updated_at', JSON.stringify(updatedAt));
    }

    static getUpdatedAt() {
        return JSON.parse(localStorage.getItem('updated_at'));
    }

    static getStudyFilters() {
        return this.getUserSettings()?.study_filters;
    }

    static getStudyFilterById(id) {
        let filters = this.getStudyFilters()
        return filters.find(item => item.id.toString() === id.toString())
    }

    static addOneNewStudyFilter(newItem) {
        let obj = this.getUserSettings()?.study_filters;
        this.setSomeUserSettings("study_filters", [...obj, newItem])
    }

    static removeOneStudyFilter(delItem) {
        let obj = this.getUserSettings()?.study_filters;
        this.setSomeUserSettings("study_filters", obj.filter(item => item.id !== delItem))
    }

    static getDefaultStudyFilter() {
        return this.getUserSettings()?.study_filters_default
    }

    static getDefaultStudyFilterID() {
        return this.getDefaultStudyFilter()?.id
    }

    static getDefaultStudyFilterStatus() {
        return this.getDefaultStudyFilter()?.used
    }

    static setDefaultStudyFilterID(id) {
        let obj = {...this.getDefaultStudyFilter(), id: id}
        this.setSomeUserSettings("study_filters_default", obj)
    }

    static setDefaultStudyFilterStatus(status) {
        let obj = {...this.getDefaultStudyFilter(), used: status}
        this.setSomeUserSettings("study_filters_default", obj)
    }

    static oneTimeDefaultStudyFilter() {
        this.setDefaultStudyFilterStatus(true)
        return this.getDefaultStudyFilterID()
    }

    static getAllAsObject() {
        const keys = ["updated_at", "user_info", "userId", "report_headers", "service_code_groups", "roles", "modalities", "ticket", "users", "pageSize", "translations", "hospitals", "user_settings"];

        let finalUpdate = {};

        keys.map(key => {
            let data ;

            try {
                data = JSON.parse(localStorage.getItem(key));
            } catch(e) {
                data = localStorage.getItem(key)
            }

            if (data) {
                finalUpdate[key] = data;
            }
        });

        return finalUpdate;
    }

    static setAllKeysAgain(data) {
        let keys = Object.keys(data);

        keys.map(key => {
            localStorage.setItem("key", JSON.stringify(data[key]));
        })
    }

    static createUserHistory(id){
        let obj = {
            splitView: false,
            fontSize: null,
            visitedRows: [],
            studyList:[],
            lastFilter:{},
            modalReporters:{},
            newStudyReport: {},
        }
        localStorage.setItem("userHistory", JSON.stringify({ [`${id}`]:obj, ...this.getUserHistory() }));
    }

    static setUserHistory(value){
        localStorage.setItem("userHistory", JSON.stringify(value));
    }

    static changeUserHistory(property, value){
        let userID = this.getUserID()
        let userHistory = this.getUserHistory(userID)
        let res = {...this.getUserHistory(), [`${userID}`]: {...userHistory, [`${property}`]: value}}
        return this.setUserHistory(res);
    }

    static getUserHistory(id=null){
        let t = JSON.parse(localStorage.getItem("userHistory"))
        if (id === null){
            return t
        } else {
            try {
                return t[id]
            } catch (e) {
                console.log("getUserHistory Not found. userID:", id)
                return null
            }
        }
    }

    static setPropertyHistory(userID, property, value){
        let t = this.getUserHistory(userID)
        if (snippets.isObjectEmpty(t)){
            this.createUserHistory(userID)
            t=this.getUserHistory(userID)
        }
        t[property] = value
        localStorage.setItem("userHistory", JSON.stringify({ ...this.getUserHistory(), [`${userID}`]:t }));
    }

    static addNewVisitedRowIDs(studyID, reportID){
        let study = {id: studyID}
        let report = {id: reportID}
        if (snippets.isObjectEmpty(studyID) || snippets.isObjectEmpty(reportID)) return
        this.addNewVisitedRow(study, report)
    }
    static addNewVisitedRow(study, report){
        let userID = this.getUserID()
        if (snippets.isObjectEmpty(userID)) return
        let updatedSet = new Set(this.getUserHistory(userID)?.visitedRows)
        let value = this.PatientsListGroupID(study, report)
        if (value) {
            updatedSet.add(value);
            this.setPropertyHistory(userID, "visitedRows", Array.from(updatedSet))
        }
    }

    static getWholeVisitedRows(userID = this.getUserID()) {
        return new Set(this.getUserHistory(userID)?.visitedRows)
    }

    static visitedRowsContains(study, report, userID = this.getUserID()) {
        let state = this.PatientsListGroupID(study, report)
        return this.visitedRowsContainsChecking(state, userID)
    }

    static visitedRowsContainsChecking(state, userID){
        if (snippets.isObjectEmpty(state)) return
        let stuID = state?.split("/")?.shift()
        let repID = state?.split("/")?.pop()
        let list = this.getWholeVisitedRows(userID)
        if (repID === "-"){
            return Array.from(list)?.some(item => item?.startsWith(`${stuID}/`))
        } else {
            return list.has(state)
        }
    }

    static setModalReporters(obj){
        let userID = this.getUserID()
        this.setPropertyHistory(userID, "modalReporters", obj)
    }

    static getModalReporters(userID = this.getUserID()){
        return this.getUserHistory(userID)?.modalReporters
    }

    static getNewStudyReport(stuID = null, repID = null, userID = null) {
        if (!snippets.isObjectEmpty(userID)) {
            let t = this.getUserHistory(userID)?.newStudyReport
            if (snippets.isObjectEmpty(stuID)) {
                return t
            } else if (!snippets.isObjectEmpty(repID)) {
                return t[`${stuID}-${repID}`]
            }
        } else if (!snippets.isObjectEmpty(stuID) && !snippets.isObjectEmpty(repID)){
            let str = `${stuID}-${repID}`
            return Object.entries(this.getUserHistory()).filter(([, v]) => !snippets.isObjectEmpty(v.newStudyReport)).map(([key, value]) => {
                return str in value.newStudyReport
                    ? {...value.newStudyReport[str], user_id: key, user_displayName: this.getUserDisplayName(key) }
                    : null
            }).filter(item => !snippets.isObjectEmpty(item))
        }
    }

    static getNewStudyReportLatest (stuID , repID) {
        let history = this.getNewStudyReport(stuID, repID)
        if (!snippets.isObjectEmpty(history)){
            return history?.reduce((prev, current) =>
                (prev.user_draft_time > current.user_draft_time) ? prev : current
            );
        } else {
            return {}
        }
    }

    static setNewStudyReport(stuID, repID, values, userID = this.getUserID()){
        let t = this.getNewStudyReport(null, null, userID)
        t[`${stuID}-${repID}`] = {...values, user_draft_time: new Date()}
        this.setPropertyHistory(userID, "newStudyReport", t)
    }

    static removeNewStudyReport(stuID, repID, userID = this.getUserID()){
        let t = this.getNewStudyReport(null, null, userID)
        delete t[`${stuID}-${repID}`]
        this.setPropertyHistory(userID, "newStudyReport", t)
    }

    static removeNewStudyReportWholes(stuID, repID){
        let t = this.getUserHistory()
        console.log("removeNewStudyReportWholes", t, stuID, repID, `${stuID}-${repID}`)
	    try {
	        Object.entries(t)?.map(([, value])=> delete value?.newStudyReport[`${stuID}-${repID}`])
	        this.setUserHistory(t)
	    } catch (e) {
			console.error('removeNewStudyReportWholes failed')
	    }
    }

    static getRedirectAfterLogin(){
        try{
            return `/${decodeURIComponent(window.location.hash.split('?')[1].split('=')[1])}`
        } catch {
            return "/"
        }
    }

    static PatientsListSave(list){
        let t = Object.entries(list).filter(([, value]) => !snippets.isObjectEmpty(value[2]))
            .map(([, value]) => {
                let isArr = Array?.isArray(value[2])
                let len = isArr && value[2].length > 1
                return {
                    id: this.PatientsListGroupID(value[0], value[2]),
                    name: value[1]?.his_or_original_full_name,
                    children: !isArr ? null
                        : len ? value[2].map(item=>item.id).map(String) : null,
                    editableChild: len ? value[2]?.filter(item=>item?.can_edit).map(item=>item?.id).map(String)
                        : value[2]?.can_edit ? value[2]?.id : []
                }
            })
        let userID = this.getUserID()
        this.setPropertyHistory(userID, "studyList", t)
    }

    static PatientsListGroupID(study, report){
        let str = `${study?.id}/`
        if (snippets.isObjectEmpty(study?.id) || snippets.isObjectEmpty(report)) {
            return undefined
        } else if (!Array.isArray(report)){
            if (!("id" in report)){
                let obj = Object.keys(report).length > 1
                    ? Object.values(report).filter(item=> item.id !== null)
                    : Object.values(report)
                return this.PatientsListGroupID(study, obj)
            } else if (snippets.isObjectEmpty(report.id)){
                return str + `0`
            } else {
                return str + report.id
            }
        } else if (Array.isArray(report)){
            if (report.length === 1){
                return snippets.isObjectEmpty(report[0]?.id) ? str + `0` : str + report[0].id
            } else if ( report.length > 1){
                return str + "-"
            }
        }
    }

    static PatientsListGet(){
        let studyList = this.getUserHistory(this.getUserID())?.studyList ?? null
        if (studyList) {
            studyList = studyList.map(item => {
                return item.id
            })
        }
        return studyList
    }

    static PatientsListFullGet(){
        return this.getUserHistory(this.getUserID())?.studyList ?? null
    }

    static PatientsListCurrentIncluded(studyID, reportID){
        let t = this.PatientsListFullGet()?.filter(item => item.id?.split("/")?.shift() === studyID)?.shift()
        if (!snippets.isObjectEmpty(t)){
            return t.id.split("/")[1] === reportID ||  t.children?.includes(reportID)
        }
    }

    static PatientsListNext(id){
        let patients = this.PatientsListFullGet()
        let study = id.split("/").shift()
        let curr = patients.filter(item => item.id.startsWith(`${study}/`)).shift()
        let next = patients[patients.indexOf(curr) + 1]
        if(!snippets.isObjectEmpty(next)){
            return {...next, url: this.PatientsListEditableURL(next)}
        }
    }

    static PatientsListPrev(id){
        let patients = this.PatientsListFullGet()
        let study = id.split("/").shift()
        let curr = patients.filter(item => item.id.startsWith(`${study}/`)).shift()
        let prev = patients[patients.indexOf(curr) - 1]
        if(!snippets.isObjectEmpty(prev)){
            return {...prev, url: this.PatientsListEditableURL(prev)}
        }
    }

    static PatientsListEditableURL(patient) {
        let study = patient.id.split("/").shift()
        return patient.id.split("/").pop() !== "-" ? patient.id : patient.editableChild?.length >= 1 ?
            `${patient.id.split("/").shift()}/${patient.editableChild.shift()}` : `${study}/${patient.children.shift()}`
    }

    static lastFiltersSave(data){
        let userID = this.getUserID()
        this.setPropertyHistory(userID, "lastFilter", data)
    }

    static lastFiltersGet(){
        return this.getUserHistory(this.getUserID())?.lastFilter
    }

    static directionGet(){
        return this.getUserSettings()?.direction
    }

    static directionIsRTL(){
        return this.directionGet().toLowerCase() === "rtl"
    }

    static studyHeaderFiltersReset(){
        let obj = userSettings.STUDY_LIST_HEADERS
        return this.setSomeUserSettings("studyHeaderFilters", obj)
    }

    static studyHeaderFiltersActiveChange(data){
        let obj = this.studyHeaderFiltersGet()
        let ans = {}
        Object.entries(obj).map(([key, value]) => {
            ans = {...ans, [key]:{...value, ...data[key]}}
        })
        return this.setSomeUserSettings("studyHeaderFilters", ans)
    }

    static studyHeaderFiltersSet(string){
        let ans = {}
        if (snippets.isObjectEmpty(string)){
            ans = userSettings.STUDY_LIST_HEADERS
        } else{
            let obj = userSettings.STUDY_LIST_HEADERS
            Object.entries(obj).map(([key, value]) => {
                ans = {...ans, [key]:{...value, active: false}}
            })
            let list = string.split(",").map((item) => ans = {...ans, [item]:{...obj[item], active: true}})
        }
        return this.setSomeUserSettings("studyHeaderFilters", ans)
    }

    static studyHeaderFiltersGet(){
        return this.getUserSettings()?.studyHeaderFilters
    }

    static splitViewGet(){
        return this.getUserHistory(this.getUserID())?.splitView
    }

    static splitViewSet(value){
        return this.setPropertyHistory(this.getUserID(), "splitView", value)
    }

    static versionGet(){
        return JSON.parse(localStorage.getItem("version"));
    }

    static pacsVersionGet(){
        try{
            return this.versionGet()["build-number"]
        } catch {
            return "0"
        }
    }

    static uiVersionSet(value){
        localStorage.setItem("version", JSON.stringify({...this.versionGet(), ui: value}))
    }

    static uiVersionGet(){
        return this.versionGet()?.ui
    }

    static getIsPublic(){
        return this.getUserSettings()?.isPublic
    }

    static setUserFontSize(size){
        return this.changeUserHistory("fontSize", size)
    }

    static getUserFontSize(){
        return this.getUserHistory(this.getUserID())?.fontSize || 14
    }
	
    static getUserIsInside(){
        return localStorage.getItem('is_inside') === 'true'
    }
    static getUserChangeLogVersion(){
        return localStorage.getItem('changeLogVersion') || 0
    }
	
    static setUserChangeLogSeen(version){
		localStorage.setItem('changeLogVersion', version)
    }
	
    static setUserDefaultCamera(id){
		localStorage.setItem('cameraID', id)
    }
	
    static getUserDefaultCamera(){
		return localStorage.getItem('cameraID')
    }
	
    static getViewersOptions(){
		return JSON.parse(localStorage.getItem('dicom_viewers'));
    }
	
    static getWebDataConfiguration(){
		return JSON.parse(localStorage.getItem('configs'));
    }
	
    static getWebDataConfSecurity(){
		return this.getWebDataConfiguration()?.security;
    }
	
    static getWebDataConfSecCheckSession(){
		return this.getWebDataConfSecurity()?.check_sessions;
    }
}

export default Storage;